// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

var context = React.createContext(undefined);

var provider = context.Provider;

function VimeoPlayer__VideoContext$Provider(props) {
  return React.createElement(provider, {
              value: props.value,
              children: props.children
            });
}

var Provider = {
  provider: provider,
  make: VimeoPlayer__VideoContext$Provider
};

export {
  context ,
  Provider ,
}
/* context Not a pure module */
